import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=bd31037a&scoped=true&"
import script from "./NewsCreate.vue?vue&type=script&lang=js&"
export * from "./NewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./NewsCreate.vue?vue&type=style&index=0&id=bd31037a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd31037a",
  null
  
)

export default component.exports